// extracted by mini-css-extract-plugin
export default {"joyn2Dropdown":"ThreeDotMenu_joyn2Dropdown__sI8IU"};